import React from 'react'
import PropTypes from 'prop-types'

const FormDashboardTextarea = ({placeholder, onChange, className, type, rows, defaultValue}) => {
  return (
    <textarea
      className={`rounded border py-2 px-4 text-sm ${className}`}
      placeholder={placeholder}
      onChange={onChange}
      style={{borderColor: '#ddd', whiteSpace: 'pre-line'}}
      type={type}
      rows={rows}
      defaultValue={defaultValue.replace('\\n', '\n')}
    />
  )
}

FormDashboardTextarea.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  rows: PropTypes.number,
  defaultValue: PropTypes.string,
}

FormDashboardTextarea.defaultProps = {
  placeholder: '',
  onChange: () => {},
  className: '',
  type: '',
  rows: 7,
  defaultValue: '',
}

export { FormDashboardTextarea }
